import actions from "./actions"
import { mutations } from "./mutations"
import getters from "./getters"
import { JobsContext, JobsFilters, JobsState } from "@/models/JobsState"

export default {
	namespaced: true,
	state: (): JobsState => {
		return {
			jobs: [],
			context: JobsContext[0],
			filters: new Set<JobsFilters>(),
			current_job: null,
			total_jobs: 0
		}
	},
	mutations,
	actions,
	getters
}
